// extracted by mini-css-extract-plugin
export default {"btn":"ExpandIcon_btn__JBhPq","icon":"ExpandIcon_icon__wR5Ra"};